export class CallbackHell {

    static createSongClickOpen: () => void = () => {}
    
    static confirmDialogPositiveCallback: () => void = () => {}
    static confirmDialogNegativeCallback: () => void = () => {}
    static confirmDialogNeutralCallback: () => void = () => {}

}